document.querySelectorAll('[data-bubble-plp]').forEach((root) => {
  const form = root.querySelector('[data-bubble-filters]');
  const cards = [...root.querySelectorAll('.swb__card')];
  const grid = root.querySelector('[data-bubble-cards]');
  const count = root.querySelector('[data-bubble-count]');
  const empty = root.querySelector('[data-bubble-empty]');
  const sorts = [...root.querySelectorAll('[data-bubble-sort]')];
  const sizeSearch = root.querySelector('[data-size-search]');

  const selected = (name) => new Set([...form.querySelectorAll('input[name="' + name + '"]:checked')].map((input) => input.value));
  const update = () => {
    const sizes = selected('size');
    const colors = selected('color');
    const packs = selected('pack');
    const min = Number(form.elements.min_price.value || 0) * 100;
    const max = form.elements.max_price.value ? Number(form.elements.max_price.value) * 100 : Infinity;
    let visible = 0;
    cards.forEach((card) => {
      const price = Number(card.dataset.price);
      const matches = (!sizes.size || sizes.has(card.dataset.format)) &&
        (!colors.size || colors.has(card.dataset.color)) &&
        (!packs.size || packs.has(card.dataset.pack)) &&
        price >= min && price <= max;
      card.hidden = !matches;
      if (matches) visible++;
    });
    count.textContent = visible + (document.documentElement.lang.toLowerCase().startsWith('en') ? (visible === 1 ? ' variant' : ' variants') : (visible === 1 ? ' Variante' : ' Varianten'));
    empty.hidden = visible !== 0;
  };
  const updateSizeList = () => {
    const query = sizeSearch.value.trim().toLocaleLowerCase();
    root.querySelectorAll('[data-size-choices] .swb__choice').forEach((choice) => {
      choice.hidden = Boolean(query) && !choice.textContent.toLocaleLowerCase().includes(query);
    });
  };
  form.addEventListener('change', update);
  form.addEventListener('input', (event) => {
    if (event.target === sizeSearch) updateSizeList();
    if (event.target.type === 'number') update();
  });
  form.addEventListener('reset', () => {
    requestAnimationFrame(() => {
      updateSizeList();
      update();
      applySort('default');
    });
  });
  const applySort = (value) => {
    sorts.forEach((select) => { select.value = value; });
    cards.sort((a, b) => value === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) :
      value === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.index) - Number(b.dataset.index));
    cards.forEach((card) => grid.append(card));
  };
  sorts.forEach((select) => select.addEventListener('change', () => applySort(select.value)));
  root.querySelector('[data-show-products]').addEventListener('click', () => root.querySelector('#product-grid').scrollIntoView({ behavior: 'smooth', block: 'start' }));
  update();
});
